
import {amountConversion} from '../../utils/util';
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'
import Panel from 'vux/src/components/panel/index.vue'
import Card from 'vux/src/components/card/index.vue'
import Grid from 'vux/src/components/grid/grid.vue'
import GridItem from 'vux/src/components/grid/grid-item.vue'
import GroupTitle from 'vux/src/components/group-title/index.vue'
import Blur from 'vux/src/components/blur/index.vue'


export default {
components: {
Tabbar,
TabbarItem,
Panel,
Card,
Grid,
GridItem,
GroupTitle,
Blur
},
data () {
return {
shopBaseInfo: {},
shopId: this.$route.params.shopId,
shopImg: 'http://p3kan57ky.bkt.clouddn.com/bnb/public/banner.jpg',
headImg: '',
shopName: null,
type: '1',
list: [{

src: 'https://o3e85j0cv.qnssl.com/hot-chocolate-1068703__340.jpg',
fallbackSrc: 'http://placeholder.qiniudn.com/60x60/3cc51f/ffffff',
title: '商家通知',
desc: '商家结算时间为每周4早上6点，请注意查看账单',
url: ''
}],
footer: {
title: '显示更多',
url: ''
},
shopStatistic: {
'yesterOrderCount' : null,
'yesterOrderPrice' : null,
'yesterMemberAddCount' : null,
'yesterCommissionAmount' : null,
}
}
},
created() {

this.initShopInfo()

this.getShopStatistic()
},
methods: {
penny2yuan(val){
return amountConversion.penny2yuan(val)
},
onItemClick () {

},
onImgError (item, $event) {

},
getShopStatistic(){
let shopId = this.shopId
let operateCode = 'SHOP_OPERATION_STATISTIC';
let _this = this;
let uri = '/v1/shop/'+shopId+'/statistic/'+operateCode;
let params = {shopId: shopId};
_this.axios.post(uri, params, {
headers: {}
}).then(function (response) {
if (response.data.code == 0) {
_this.shopStatistic.yesterOrderCount = response.data.data.yesterOrderCount
_this.shopStatistic.yesterOrderPrice = response.data.data.yesterOrderPrice
_this.shopStatistic.yesterMemberAddCount = response.data.data.yesterMemberAddCount
_this.shopStatistic.yesterCommissionAmount = response.data.data.yesterCommissionAmount
} else {

console.log('处理错误提醒');
}
}).catch(function (response) {
console.log(response);

});
},
initShopInfo(){
let shopId = this.shopId
let _this = this;
let uri = '/v1/shop/'+ shopId;
let params = null;
_this.axios.get(uri, params, {
headers: {}
}).then(function (response) {
if (response.data.code != undefined && response.data.code == 0) {
_this.shopBaseInfo = response.data.data
_this.headImg = response.data.data.userInfo.headImg
_this.shopName = response.data.data.name
} else {

console.log('处理错误提醒');
}
}).catch(function (response) {
console.log(response);

});
}
}
}



// WEBPACK FOOTER //
// ./src/components/shop/Index.vue